import { onLCP, onCLS, onINP, onFCP, onTTFB } from 'web-vitals';

/**
 * Reports Web Vitals metrics.
 * Since this application is zoneless, monitoring INP (Interaction to Next Paint)
 * is especially important to ensure manual change detection is performing well.
 */
export function reportWebVitals(onPerfEntry?: (metric: any) => void) {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
    onINP(onPerfEntry);
  }
}
